import { confirmable, createConfirmation } from 'react-confirm';
import { Confirmation } from '@/components/custom/react-confirm/Confirmation.tsx';

export function confirm(confirmation: any, options = {}): Promise<any> {
	return createConfirmation(confirmable(Confirmation))({
		confirmation,
		...options,
	} as any);
}
